import React from 'react';
import { Link } from 'react-router-dom';

interface GuidLinkProps {
  id: string;
  name?: string;
  entityName: string;
}

export function GuidLink({ id, name, entityName }: GuidLinkProps) {
  return (
    <Link
      to={`/${entityName}/${id}`}
      className="text-blue-600 hover:text-blue-800 hover:underline"
    >
      {name || id.substring(0, 8) + '...'}
    </Link>
  );
}
